import areSamePoints from '@atlas/tool/box/slate/areSamePoints';
import { Editor, Transforms, Text } from 'slate';

export default function addLink(editor: Editor, link = '') {
    if (!editor.selection) return false;

    const isCollapsed = areSamePoints(editor.selection.anchor, editor.selection.focus);

    Transforms.setNodes(
        editor,
        { link },
        isCollapsed
            ? { at: editor.selection.focus.path.slice(0, -1) }
            : { match: (node) => Text.isText(node), split: true },
    );

    return true;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('addLink', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
